import { sitePhrasing } from "../../Language/languageHandler"
import { ShoppingState } from "./shoppingSlice"


const removeProductsBasedOnState: { [key: string]: string[] } = {
  Virginia: ['principalAddressChanges', 'registeredAgentChanges'],
}

export const productValues: any = {
  annualReport: {
    name: 'Annual Report',
    // name: sitePhrasing.state === 'Florida' ? 'Annual Report' : `Annual Report & Certificate of ${sitePhrasing.certificateOf}`,
    // name: `Annual Report & Certificate of ${sitePhrasing.certificateOf}`,
    price: 29989,
    // deleteProducts: ['einTaxId', ...(removeProductsBasedOnState[sitePhrasing.state] || [])],
    // deleteProducts: ['einTaxId', 'certificateOfStatus'],
    // hideIfSelected: ['einTaxId'],
    customClass: '',
    // lateFee: 2500,
    // lateFeeName: 'Annual Report Late Fee',
    // lateFeeStart: '12/01/2024 10:00am',
    // lateFeeEnd: '12/02/2024 11:55pm',
  },
  einTaxId: {
    name: 'EIN / Tax ID',
    price: 19995,
    // deleteProducts: ['annualReport'],
    // hideIfSelected: ['annualReport'],
    customClass: '',
  },
  laborLawPoster: {
    name: 'Labor Law Poster',
    price: 12495,
    customClass: '',
  },
  certificateOfStatus: {
    name: `Certificate of ${sitePhrasing.certificateOf}`,
    price: 8995,
    // deleteProducts: ['annualReport'],
    // hideIfSelected: ['annualReport'],
    customClass: '',
    // hidden: true,
  },
}

export const productKeySort: any = {
    annualReport: 1,
    annualRegistration: 2,
    initialRegistration: 2,
    einTaxId: 3,
    fictitiousNameRenewal: 4,
    legalNoticeAdvertisement: 5,
    amend: 6,
    reinstate: 7,
    certificateOfStatus: 8,
    articlesOfIncorporation: 9,
    registeredAgentChanges: 10,
    additionalMembers: 11,
    annualReportLateFee: 12,
    laborLawPoster: 13,
  }

export const promoCodes: {
  [key: string]: { id: 'string', amount: number }
} = {}

export const updateProductPrice = (productKey: string, price: number, extraInfo: any = {}) => {
  productValues[productKey] = {
    ...productValues[productKey],
    price,
    ...extraInfo
  }
  // productValues[productKey].price = price
}


export const extraOfferings: any[] = []
// export const extraOfferings: any[] = [{
//   title: 'Annual Reports for Existing Customers',
//   offers: {
//     annualReport: {
//       name: 'Annual Report & Certificate of Status',
//       price: 29989,
//       linkTo: 'https://www.google.com',
//       customClass: '',
//     }
//   }
// }]

export const shippingOptions: any = {
  electronic: {
    id: 'electronic',
    name: 'Electronic via Email',
    subText1: 'No additional shipping charges & expedited Delivery!',
    subText2: 'Usually processed the next business day, but may take up to 3 business days.',
    amount: 0
  },
  physical: {
    id: 'physical',
    name: 'Physical via USPS Mail',
    subText1: 'Additional $8.25 shipping cost',
    subText2: 'May take up to 14 business days to receive by mail.',
    amount: 825
  }
}

export const customShippingOptions: any = {
  'legalNoticeAdvertisement': {
    electronic: {
      id: 'electronic',
      name: 'Electronic via Email',
      subText1: 'No additional shipping charges & expedited Delivery!',
      subText2: 'May take 1-2 weeks to be published, depending on the day and time the order is received. Once your ad is published, allow an additional 1-2 weeks to receive your copy and notarized affidavit.',
      amount: 0
    },
    physical: {
      id: 'physical',
      name: 'Physical via USPS Mail',
      subText1: 'Additional $8.25 shipping cost',
      subText2: 'May take 1-2 weeks to be published, depending on the day and time the order is received. Once your ad is published, allow an additional 2-3 weeks to receive your copy and notarized affidavit.',
      amount: 825
    }
  }
}

export const discountOffers = [

  {
    amount: 7500,
    selection: ['laborLawPoster', 'certificateOfStatus', 'initialRegistration', 'einTaxId']
  },

  {
    amount: 6495,
    selection: ['laborLawPoster', 'certificateOfStatus', 'annualReport']
  },
  {
    amount: 6495,
    selection: ['laborLawPoster', 'certificateOfStatus', 'annualRegistration']
  },

  {
    amount: 4000,
    selection: ['certificateOfStatus', 'annualReport']
  },
  {
    amount: 4000,
    selection: ['certificateOfStatus', 'annualRegistration']
  },
  
  {
    amount: 2495,
    selection: ['laborLawPoster', 'legalNoticeAdvertisement']
  },

  {
    amount: 2495,
    selection: ['laborLawPoster', 'annualReport']
  },
  {
    amount: 2495,
    selection: ['laborLawPoster', 'annualRegistration']
  },
  {
    amount: 1496,
    selection: ['laborLawPoster', 'certificateOfStatus', 'einTaxId']
  },
  {
    amount: 1500,
    selection: ['laborLawPoster', 'certificateOfStatus']
  },
]

export const upsellDiscountOffers = [
  {
    amount: 5500,
    selection: ['laborLawPoster', 'legalNoticeAdvertisement']
  },
]

export const updateCartInfo = (cartState: ShoppingState, update: {
  shipping?: string,
  product?: string,
  updateProductInfo?: boolean,
  isUpsell?: boolean,
  promoCode?: string
}) => {
  const state = {
    ...cartState
  }

  const {
    shipping,
    product,
    updateProductInfo,
    isUpsell,
    promoCode
  } = update

  if (shipping && shippingOptions[shipping]) {
    state.shippingMethod = shippingOptions[shipping].id
    state.shippingTotal = shippingOptions[shipping].amount
  }

  // Add products to cart
  const updatedProducts = {
    ...state.selectedProducts,
  }

  if (product && productValues[product]) {
    const productInfo = productValues[product]
    const {
      name,
      lateFee,
      lateFeeName
    } = productInfo

    const lateFeeId = `${product}LateFee`
    const lateProduct = {
      name: lateFeeName ? lateFeeName : `${name} Late Fee`,
      price: lateFee,
    }

    if (updateProductInfo && updatedProducts[product]) {
      delete updatedProducts[product]
    }

    if (!updatedProducts[product]) {
      updatedProducts[product] = { ...productValues[product] }
      if (isUpsell) {
        updatedProducts[product].isUpsell = true
      }

      if (productValues[product].selectQuantity) {
        updatedProducts[product].quantity = productValues[product].minQuantity || 1
      }

      if (lateFee) {
        updatedProducts[lateFeeId] = lateProduct
      }

      if (productValues[product].deleteProducts) {
        productValues[product].deleteProducts.forEach((x: string) => {
          delete updatedProducts[x]
        })
      }
    } else {
      delete updatedProducts[product]
      if (lateFee) {
        delete updatedProducts[lateFeeId]
      }
    }
  }

  // BEGIN SORTING PRODUCT KEYS
  // state.selectedProducts = {
  //   ...updatedProducts
  // }
  state.selectedProducts = {}
  
  const sortedProductKeys = Object.keys(updatedProducts).sort((aKey: string, bKey: string) => {
    if (productKeySort[aKey] && productKeySort[aKey]) {
      if (productKeySort[aKey] < productKeySort[bKey]) { return -1 }
      return 1
    }

    if (aKey < bKey) { return -1 }
    return 1
  })
  sortedProductKeys.forEach((p) => {
    state.selectedProducts[p] = { ...updatedProducts[p] }
  })
  // END SORTING PRODUCT KEYS

  if (promoCode && promoCodes[promoCode]) {
    console.log('promoCode', promoCode, promoCodes[promoCode])
    console.log(promoCodes[promoCode].id, promoCodes[promoCode].amount)
    state.discountId = promoCodes[promoCode].id
    state.discount = promoCodes[promoCode].amount
    console.log(state)
  } else {
    state.discountId = ''
    state.discount = 0
  }

  // check for discounts
  if (!state.prepaid && !state.discountId) {
    // console.log('checking for discounts', state.discountId, state)
    let productSelectedIsPartOfUpsell = false
    if (state.step === 3 && product) {
      productSelectedIsPartOfUpsell = upsellDiscountOffers.some((d) => {
        return d.selection.includes(product)
      })
    }
    const validDiscounts = ([...(productSelectedIsPartOfUpsell ? upsellDiscountOffers : []), ...discountOffers]).filter((d) => {
      let valid = true
      d.selection.forEach((s) => {
        if (!state.selectedProducts[s]) {
          valid = false
        }
      })
      return valid
    })
    if (validDiscounts.length > 0) {
      state.discount = validDiscounts[0].amount
    } else {
      state.discount = 0
    }
  }

  // update cart total
  let total = 0
  if (state.selectedProducts) {
    Object.keys(state.selectedProducts).forEach((p) => {
      const qty = state.selectedProducts[p].quantity || 1
      total += state.selectedProducts[p].price * qty
    });
    // total -= state.discount ? state.discount : 0
    state.cartTotal = total
  } else {
    state.cartTotal = 0
  }

  // check if discount is greater than cart total
  if (state.discount > state.cartTotal) {
    state.discount = 0
  }

  return state
}


export type SpecialPricingType = {
  [state: string]: {
    [product: string]: {
      sectionTitle: string,
      productKey: string,
      values: {
        [product: string]: {
          name: string,
          subText?: string,
          price: number,
          customProductInfo?: {
            [key: string]: any
          }
        }
      }
    }
  }
}


export const specialPricingRequired: SpecialPricingType = {
  'Mississippi': {
    'annualReport': {
      sectionTitle: 'Select your business entity structure:',
      productKey: 'annualReport',
      values: {
        'domesticLLC': {
          name: 'Domestic LLC',
          subText: 'Formed & operating in the state of MS',
          price: 29989
        },
        'foreignLLC': {
          name: 'Foreign LLC',
          subText: 'Formed in another state but operating in MS',
          price: 49989
        },
        'corporation': {
          name: 'Corporation',
          // subText: '',
          price: 29989
        },
        'nonProfit': {
          name: 'Non-Profit',
          // subText: '',
          price: 29989
        },
        'other': {
          name: 'Other',
          // subText: '',
          price: 29989
        },
      },

    },
    'amend': {
      sectionTitle: 'Select your business entity structure:',
      productKey: 'amend',
      values: {
        'domesticLLC': {
          name: 'Domestic LLC',
          subText: 'Operating in the state of MS',
          price: 10000
        },
        'corporation': {
          name: 'Corporation',
          // subText: '',
          price: 10000
        },
        'nonProfit': {
          name: 'Non-Profit',
          // subText: '',
          price: 10000
        },
        'foreignLLC': {
          name: 'Foreign LLC',
          subText: 'Operating outside the state of MS',
          price: 10000
        },
        'other': {
          name: 'Other',
          // subText: '',
          price: 10000
        },
      },

    },
  },
  'Virginia': {
    'annualReport': {
      sectionTitle: 'Select your business entity structure:',
      productKey: 'annualReport',
      values: {
        'llc': {
          name: 'LLC',
          // subText: '',
          price: 29989,
          customProductInfo: {
            // Add any custom product information here
            name: 'Annual Registration'
          }
        },
        'stockCorporation': {
          name: 'Stock Corporation',
          subText: `For-profit corporation, formed to generate a profit for shareholders.`,
          price: 39989,
          customProductInfo: {
            // Add any custom product information here
            name: 'Annual Report & Annual Registration'
          }
        },
        'nonStockCorporation': {
          name: 'Non-Stock Corporation',
          subText: `Non-profit corporation, organized for not-for-profit purposes, such as a tax-exempt, charitable organization or a property owners' association.`,
          price: 39989,
          customProductInfo: {
            // Add any custom product information here
            name: 'Annual Report & Annual Registration'
          }
        },
      }
    },
    'amend': {
      sectionTitle: 'Select your business entity structure:',
      productKey: 'amend',
      values: {
        'llc': {
          name: 'LLC',
          // subText: '',
          price: 10000,
          customProductInfo: {
            // Add any custom product information here
            name: 'Business Amendment'
          }
        },
        'stockCorporation': {
          name: 'Stock Corporation',
          subText: `For-profit corporation, formed to generate a profit for shareholders.`,
          price: 10000,
          customProductInfo: {
            // Add any custom product information here
            name: 'Business Amendment & Annual Registration'
          }
        },
        'nonStockCorporation': {
          name: 'Non-Stock Corporation',
          subText: `Non-profit corporation, organized for not-for-profit purposes, such as a tax-exempt, charitable organization or a property owners' association.`,
          price: 10000,
          customProductInfo: {
            // Add any custom product information here
            name: 'Business Amendment & Annual Registration'
          }
        },
      }
    }
  }
}